import { getIn } from 'formik'

export function serverErrorsOf(status, values) {
    const recorded = status?.serverErrors ?? {}

    return Object.entries(recorded).reduce((shown, [name, entry]) => {
        if (getIn(values, name) === entry.value) {
            shown[name] = entry.message
        }

        return shown
    }, {})
}

export function serverErrorOf(status, values, name) {
    const shown = serverErrorsOf(status, values)

    return shown[name]
}

export function applyServerErrors(formik, fieldErrors, values = formik.values) {
    const current = formik.status?.serverErrors ?? {}
    const added = Object.entries(fieldErrors).reduce((entries, [name, message]) => {
        entries[name] = {
            message,
            value: getIn(values, name),
        }

        return entries
    }, {})

    formik.setStatus({
        ...formik.status,
        serverErrors: {
            ...current,
            ...added,
        },
    })
}

export function clearServerErrors(formik) {
    formik.setStatus({
        ...formik.status,
        serverErrors: {},
    })
}
